const config = {
    NotificationConfig: {
        DefaultAutoHide: 2000,
        PersistAllNotifications: false,
        PersistErrorNotifications: false,
    },
    Roles: {
        Administrator: 'Administrator',
        OrganizationAdministrator: 'Organization Administrator',
    },
};

export default config;



// WEBPACK FOOTER //
// ./src/config.ts